import type { FluidSharedTree } from "../../fluid/fluid.client.js";
import { resolveCurrentPosition } from "./position-resolver.js";
import { getOnlineOccupantIds } from "./position-state-builder.js";

export const getPositionSignature = ({
  selfUserId,
  sharedTree,
}: {
  selfUserId: string;
  sharedTree: FluidSharedTree;
}): string => {
  const position = resolveCurrentPosition({ selfUserId, sharedTree });

  if (position.type === "none") {
    return "";
  }

  const sortedOccupants = getOnlineOccupantIds({
    alwaysIncludeUserIds: [selfUserId],
    occupantIds: position.occupantIds,
    sharedTree,
  })
    .sort((left, right) => left.localeCompare(right))
    .join(",");

  return `${position.type}:${position.locationId}:${sortedOccupants}`;
};
